import Notification from '@stimulus-components/notification'

export default Notification
